import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eaec38b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "property-type" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h4 property-type__title" }, " What type of property do you live in? ", -1))
const _hoisted_3 = {
  key: 0,
  class: "property-type__flat-alert",
  "data-testid": "property-type-flat-alert",
  role: "alert"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-alert property-type__flat-alert-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = { class: "property-type__flat-alert-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Continue", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon property-type__next-button--icon icon-arrow-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_RadioGroup, {
      modelValue: _ctx.selectedOption,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOption) = $event)),
      class: "property-type__options",
      options: _ctx.propertyTypeOptions
    }, null, 8, ["modelValue", "options"]),
    (_ctx.isFlatSelected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, [
            _createTextVNode(" Unfortunately solar panels aren't available for most flats yet. If you live in a flat where you own the roof space "),
            _createVNode(_component_router_link, {
              to: { name: _ctx.registerInterestRoute, query: { covered: 'true' } },
              "data-testid": "property-type-register-interest"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" speak to our team ")
              ], undefined, true),
              _: 1
            }, 8, ["to"]),
            _createTextVNode(" to see if we can help. ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_AppButton, {
      class: "property-type__next-button",
      "full-width": "",
      disabled: !_ctx.selectedOption || _ctx.isFlatSelected,
      size: "large",
      "data-testid": "property-type-continue",
      onClick: _ctx.next
    }, {
      default: _withCtx(() => [
        _hoisted_6,
        _hoisted_7
      ], undefined, true),
      _: 1
    }, 8, ["disabled", "onClick"])
  ]))
}